import { ref, computed } from "vue"
import { defineStore } from "pinia"
import { Preferences } from "@capacitor/preferences"

export const useFruitBackground = defineStore("fruit-background", () => {
	const showBg = ref(false)

	async function load() {
		const { value } = await Preferences.get({
			key: "gv-fruit-bg",
		})
		const v = value ?? "true"
		showBg.value = v === "true"
	}

	async function setShowBg(value) {
		showBg.value = value
		await Preferences.set({
			key: "gv-fruit-bg",
			value: value ? "true" : "false",
		})
	}

	const isOn = computed(() => showBg.value)

	return { isOn, setShowBg, load }
})
